//api/alert.js
import ajax from "../assets/uilt/ajax";

let alert = {
  // Mark alert as read
  markAsRead: (req) => {
    return ajax.post({
      url: "/back/alert/mark-read",
      param: req.param,
      success: req.success,
    });
  },

  // Resolve alert
  resolveAlert: (req) => {
    return ajax.post({
      url: "/back/alert/resolve",
      param: req.param,
      success: req.success,
    });
  },

  // Trigger manual alert check
  checkNow: (req) => {
    return ajax.post({
      url: "/back/alert/check-now",
      param: req.param,
      success: req.success,
    });
  },

  // Get alert statistics
  getStatistics: (req) => {
    return ajax.get({
      url: "/back/alert/statistics",
      param: req.param,
      success: req.success,
    });
  },

  // Get recent alerts
  getRecentAlerts: (req) => {
    return ajax.get({
      url: "/back/alert/recent",
      param: req.param,
      success: req.success,
    });
  },

  // Get all alerts with pagination
  getAlertsList: (req) => {
    return ajax.get({
      url: "/back/alert/list",
      param: req.param,
      success: req.success,
    });
  },

  //
};

export default alert;
